import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LocaleStoreService } from '../store/locale-store.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(public authStore: AuthStoreService, private localeStore: LocaleStoreService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      (request.url.includes(environment.api.core.baseUrl) || request.url.includes(environment.api.core.bankingUrl)) &&
      !request.url.includes('email/view') &&
      !request.url.includes('unsubscribe')
    ) {
      return this.authStore.getSingleUserSession$().pipe(
        switchMap((userSession) => {
          const token = userSession.getIdToken().getJwtToken();
          const headers: any = {
            Authorization: `Bearer ${token}`,
          };

          const impersonateUserId = this.authStore.getImpersonatedUserId();
          if (impersonateUserId) {
            headers['admin-impersonate-user-id'] = impersonateUserId;
          }

          const localeCode = this.localeStore.currentLocaleCode;
          if (localeCode != null) {
            headers['X-Locale-Code'] = localeCode;
          }

          const tempRequest = request.clone({
            setHeaders: headers,
          });

          return next.handle(tempRequest);
        })
      );
    }

    return next.handle(request);
  }
}
